import type { User } from '../../types/comments';
import { EntityCommentThread } from './EntityCommentThread';

interface EmailThreadCommentThreadProps {
  emailThreadId: string;
  users: User[];
  currentUser: User;
  isReadOnly?: boolean;
}

/** Thin adapter over {@link EntityCommentThread} for a Gmail email thread's discussion. */
export function EmailThreadCommentThread({
  emailThreadId,
  ...rest
}: EmailThreadCommentThreadProps) {
  return <EntityCommentThread target={{ type: 'emailThread', emailThreadId }} {...rest} />;
}
